// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddEquipmentData, AddEquipmentErrors, AddEquipmentResponses, BulkDeleteFilterByIdData, BulkDeleteFilterByIdResponses, BulkUpdateFilterData, BulkUpdateFilterResponses, ClearCacheData, ClearCacheErrors, ClearCacheResponses, DeleteApiV1BlobByPrognosisIdByBlobNameData, DeleteApiV1BlobByPrognosisIdByBlobNameErrors, DeleteApiV1BlobByPrognosisIdByBlobNameResponses, DeleteApiV1FieldValuesAreasByIdData, DeleteApiV1FieldValuesAreasByIdErrors, DeleteApiV1FieldValuesAreasByIdResponses, DeleteApiV1FieldValuesByIdData, DeleteApiV1FieldValuesByIdErrors, DeleteApiV1FieldValuesByIdResponses, DeleteApiV1FilterByIdData, DeleteApiV1FilterByIdErrors, DeleteApiV1FilterByIdResponses, DeleteApiV1PrognosesByIdData, DeleteApiV1PrognosesByIdErrors, DeleteApiV1PrognosesByIdResponses, DeleteApiV1PrognosesDetailsData, DeleteApiV1PrognosesDetailsErrors, DeleteApiV1PrognosesDetailsResponses, DeleteApiV1PrognosisSubscriptionData, DeleteApiV1PrognosisSubscriptionErrors, DeleteApiV1PrognosisSubscriptionResponses, DeleteFilterByIdData, DeleteFilterByIdResponses, GetApiV1AreaAssignmentFieldByFieldGuidData, GetApiV1AreaAssignmentFieldByFieldGuidErrors, GetApiV1AreaAssignmentFieldByFieldGuidResponses, GetApiV1BlobAccessTokenData, GetApiV1BlobAccessTokenErrors, GetApiV1BlobAccessTokenResponses, GetApiV1BlobByPrognosisIdByBlobNameData, GetApiV1BlobByPrognosisIdByBlobNameErrors, GetApiV1BlobByPrognosisIdByBlobNameResponses, GetApiV1CiWellTargetsByTargetUuidData, GetApiV1CiWellTargetsByTargetUuidErrors, GetApiV1CiWellTargetsByTargetUuidResponses, GetApiV1CiWellTargetsFieldByFieldUuidData, GetApiV1CiWellTargetsFieldByFieldUuidErrors, GetApiV1CiWellTargetsFieldByFieldUuidResponses, GetApiV1FieldValuesFieldByFieldUuidData, GetApiV1FieldValuesFieldByFieldUuidErrors, GetApiV1FieldValuesFieldByFieldUuidResponses, GetApiV1FieldValuesFieldValuesWarningByFieldUuidData, GetApiV1FieldValuesFieldValuesWarningByFieldUuidErrors, GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponses, GetApiV1FilterData, GetApiV1FilterErrors, GetApiV1FilterResponses, GetApiV1HealthData, GetApiV1HealthResponses, GetApiV1OptionalAttributesByPrognosisIdData, GetApiV1OptionalAttributesByPrognosisIdErrors, GetApiV1OptionalAttributesByPrognosisIdResponses, GetApiV1OsduWellboresByWellboreIdentifierWellpathsData, GetApiV1OsduWellboresByWellboreIdentifierWellpathsErrors, GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponses, GetApiV1OsduWellpathsByIdData, GetApiV1OsduWellpathsByIdErrors, GetApiV1OsduWellpathsByIdResponses, GetApiV1PozoPrognosisByIdFaultsData, GetApiV1PozoPrognosisByIdFaultsErrors, GetApiV1PozoPrognosisByIdFaultsResponses, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthData, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthErrors, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponses, GetApiV1PrognosesByIdData, GetApiV1PrognosesByIdErrors, GetApiV1PrognosesByIdOutdatedEntriesData, GetApiV1PrognosesByIdOutdatedEntriesErrors, GetApiV1PrognosesByIdOutdatedEntriesResponses, GetApiV1PrognosesByIdResponses, GetApiV1PrognosesByPrognosisIdDetailsData, GetApiV1PrognosesByPrognosisIdDetailsErrors, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedData, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedErrors, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponses, GetApiV1PrognosesByPrognosisIdDetailsResponses, GetApiV1PrognosesByPrognosisIdHistoryData, GetApiV1PrognosesByPrognosisIdHistoryErrors, GetApiV1PrognosesByPrognosisIdHistoryResponses, GetApiV1PrognosesByPrognosisIdLastSubmittedData, GetApiV1PrognosesByPrognosisIdLastSubmittedErrors, GetApiV1PrognosesByPrognosisIdLastSubmittedResponses, GetApiV1PrognosesByPrognosisIdOverlappingData, GetApiV1PrognosesByPrognosisIdOverlappingErrors, GetApiV1PrognosesByPrognosisIdOverlappingResponses, GetApiV1PrognosesByPrognosisIdRevisionsData, GetApiV1PrognosesByPrognosisIdRevisionsErrors, GetApiV1PrognosesByPrognosisIdRevisionsNewestData, GetApiV1PrognosesByPrognosisIdRevisionsNewestErrors, GetApiV1PrognosesByPrognosisIdRevisionsNewestResponses, GetApiV1PrognosesByPrognosisIdRevisionsResponses, GetApiV1PrognosesData, GetApiV1PrognosesDetailsCommingledHistoricData, GetApiV1PrognosesDetailsCommingledHistoricErrors, GetApiV1PrognosesDetailsCommingledHistoricResponses, GetApiV1PrognosesDetailsHistoricData, GetApiV1PrognosesDetailsHistoricErrors, GetApiV1PrognosesDetailsHistoricResponses, GetApiV1PrognosesDetailsTypesData, GetApiV1PrognosesDetailsTypesErrors, GetApiV1PrognosesDetailsTypesResponses, GetApiV1PrognosesEdmWellboreByEdmWellboreIdData, GetApiV1PrognosesEdmWellboreByEdmWellboreIdErrors, GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponses, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdData, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdErrors, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponses, GetApiV1PrognosesErrors, GetApiV1PrognosesLookupValuesData, GetApiV1PrognosesLookupValuesErrors, GetApiV1PrognosesLookupValuesResponses, GetApiV1PrognosesResponses, GetApiV1PrognosesSyncData, GetApiV1PrognosesSyncErrors, GetApiV1PrognosesSyncResponses, GetApiV1PrognosesSyncWithDetailsData, GetApiV1PrognosesSyncWithDetailsErrors, GetApiV1PrognosesSyncWithDetailsResponses, GetApiV1ReservoirZonesLastUsedData, GetApiV1ReservoirZonesLastUsedErrors, GetApiV1ReservoirZonesLastUsedResponses, GetApiV1ReservoirZonesTopUsedData, GetApiV1ReservoirZonesTopUsedErrors, GetApiV1ReservoirZonesTopUsedResponses, GetApiV1SamUserAnalyticsPrognosisData, GetApiV1SamUserAnalyticsPrognosisErrors, GetApiV1SamUserAnalyticsPrognosisResponses, GetApiV1SmdaFieldsByFieldUuidStratColumnsData, GetApiV1SmdaFieldsByFieldUuidStratColumnsErrors, GetApiV1SmdaFieldsByFieldUuidStratColumnsResponses, GetApiV1SmdaFieldsByFieldUuidWellboresAllData, GetApiV1SmdaFieldsByFieldUuidWellboresAllErrors, GetApiV1SmdaFieldsByFieldUuidWellboresAllResponses, GetApiV1SmdaWellboresByWellboreIdentifierData, GetApiV1SmdaWellboresByWellboreIdentifierErrors, GetApiV1SmdaWellboresByWellboreIdentifierResponses, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickData, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickErrors, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponses, GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllData, GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllErrors, GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponses, GetApiV1SsdlWellboresByWellboreUuidPerforationsData, GetApiV1SsdlWellboresByWellboreUuidPerforationsErrors, GetApiV1SsdlWellboresByWellboreUuidPerforationsResponses, GetApiV1UserAccessCheckCollectionByFieldUuidData, GetApiV1UserAccessCheckCollectionByFieldUuidErrors, GetApiV1UserAccessCheckCollectionByFieldUuidResponses, GetApiV1UserApproversByFieldIdentifierAllData, GetApiV1UserApproversByFieldIdentifierAllErrors, GetApiV1UserApproversByFieldIdentifierAllResponses, GetApiV1UserApproversByFieldIdentifierBackupAllData, GetApiV1UserApproversByFieldIdentifierBackupAllErrors, GetApiV1UserApproversByFieldIdentifierBackupAllResponses, GetApiV1UserApproversByFieldIdentifierBackupData, GetApiV1UserApproversByFieldIdentifierBackupErrors, GetApiV1UserApproversByFieldIdentifierBackupResponses, GetApiV1UserApproversByFieldIdentifierData, GetApiV1UserApproversByFieldIdentifierErrors, GetApiV1UserApproversByFieldIdentifierResponses, GetApiV1UserData, GetApiV1UserDefaultViewData, GetApiV1UserDefaultViewErrors, GetApiV1UserDefaultViewResponses, GetApiV1UserErrors, GetApiV1UserFutureAccessesData, GetApiV1UserFutureAccessesErrors, GetApiV1UserFutureAccessesResponses, GetApiV1UserPhotoByShortnameData, GetApiV1UserPhotoByShortnameErrors, GetApiV1UserPhotoByShortnameResponses, GetApiV1UserResponses, GetApiV1UserShortnamesData, GetApiV1UserShortnamesErrors, GetApiV1UserShortnamesResponses, GetApiV1UserSubmittersByFieldIdentifierAllData, GetApiV1UserSubmittersByFieldIdentifierAllErrors, GetApiV1UserSubmittersByFieldIdentifierAllResponses, GetApiV1UserSubmittersByFieldIdentifierData, GetApiV1UserSubmittersByFieldIdentifierErrors, GetApiV1UserSubmittersByFieldIdentifierResponses, GetApiV1UserUserAccessData, GetApiV1UserUserAccessErrors, GetApiV1UserUserAccessResponses, GetAreasData, GetAreasErrors, GetAreasResponses, GetConfigData, GetConfigResponses, GetDataTypesData, GetDataTypesResponses, GetDrilledWellsFeaturesByFieldData, GetDrilledWellsFeaturesByFieldResponses, GetEquipmentData, GetEquipmentErrors, GetEquipmentResponses, GetFieldConfigData, GetFieldConfigResponses, GetFieldConfigsData, GetFieldConfigsResponses, GetFieldFaultLinesData, GetFieldFaultLinesErrors, GetFieldFaultLinesResponses, GetFieldOutlinesData, GetFieldOutlinesErrors, GetFieldOutlinesResponses, GetFilterByIdData, GetFilterByIdResponses, GetFiltersData, GetFiltersResponses, GetHelpLinesData, GetHelpLinesResponses, GetMeasurementTypesData, GetMeasurementTypesResponses, GetPiLinePlotData, GetPiLinePlotResponses, GetPressureDataByFieldFlatData, GetPressureDataByFieldFlatResponses, GetPressureHeatmapData, GetPressureHeatmapErrors, GetPressureHeatmapResponses, GetPressureTypesData, GetPressureTypesResponses, GetSamPortalProductionTokenData, GetSamPortalProductionTokenResponses, GetSamPortalTokenData, GetSamPortalTokenResponses, GetStatPressHelpLinesData, GetStatPressHelpLinesResponses, GetTokenData, GetTokenResponses, GetWellpositionsData, GetWellpositionsErrors, GetWellpositionsResponses, GetWellsInAreaData, GetWellsInAreaResponses, PatchApiV1FilterByIdData, PatchApiV1FilterByIdErrors, PatchApiV1FilterByIdResponses, PatchApiV1PrognosesByIdApproveData, PatchApiV1PrognosesByIdApproveErrors, PatchApiV1PrognosesByIdApproveResponses, PatchApiV1PrognosesByIdDismissApprovalRetractionData, PatchApiV1PrognosesByIdDismissApprovalRetractionErrors, PatchApiV1PrognosesByIdDismissApprovalRetractionResponses, PatchApiV1PrognosesByIdDismissArchivingData, PatchApiV1PrognosesByIdDismissArchivingErrors, PatchApiV1PrognosesByIdDismissArchivingResponses, PatchApiV1PrognosesByIdExpireData, PatchApiV1PrognosesByIdExpireErrors, PatchApiV1PrognosesByIdExpireResponses, PatchApiV1PrognosesByIdRejectData, PatchApiV1PrognosesByIdRejectErrors, PatchApiV1PrognosesByIdRejectResponses, PatchApiV1PrognosesByIdRequestApprovalRetractionData, PatchApiV1PrognosesByIdRequestApprovalRetractionErrors, PatchApiV1PrognosesByIdRequestApprovalRetractionResponses, PatchApiV1PrognosesByIdRequestArchivingData, PatchApiV1PrognosesByIdRequestArchivingErrors, PatchApiV1PrognosesByIdRequestArchivingResponses, PatchApiV1PrognosesByIdRetractData, PatchApiV1PrognosesByIdRetractErrors, PatchApiV1PrognosesByIdRetractResponses, PatchApiV1PrognosesByIdReturnToDraftData, PatchApiV1PrognosesByIdReturnToDraftErrors, PatchApiV1PrognosesByIdReturnToDraftResponses, PatchApiV1PrognosesByIdStep1Data, PatchApiV1PrognosesByIdStep1Errors, PatchApiV1PrognosesByIdStep1Responses, PatchApiV1PrognosesByIdStep2Data, PatchApiV1PrognosesByIdStep2Errors, PatchApiV1PrognosesByIdStep2Responses, PatchApiV1PrognosesByIdStep3Data, PatchApiV1PrognosesByIdStep3Errors, PatchApiV1PrognosesByIdStep3Responses, PatchApiV1PrognosesByIdStep5Data, PatchApiV1PrognosesByIdStep5Errors, PatchApiV1PrognosesByIdStep5Responses, PatchApiV1PrognosesByIdStepData, PatchApiV1PrognosesByIdStepErrors, PatchApiV1PrognosesByIdStepResponses, PatchApiV1PrognosesByIdSubmitData, PatchApiV1PrognosesByIdSubmitErrors, PatchApiV1PrognosesByIdSubmitResponses, PatchApiV1PrognosesDetailsByDetailIdCommentData, PatchApiV1PrognosesDetailsByDetailIdCommentErrors, PatchApiV1PrognosesDetailsByDetailIdCommentResponses, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneData, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneErrors, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponses, PostApiV1AreaAssignmentAssignWellboresData, PostApiV1AreaAssignmentAssignWellboresErrors, PostApiV1AreaAssignmentAssignWellboresResponses, PostApiV1BlobByPrognosisIdData, PostApiV1BlobByPrognosisIdErrors, PostApiV1BlobByPrognosisIdResponses, PostApiV1FieldValuesAreasData, PostApiV1FieldValuesAreasErrors, PostApiV1FieldValuesAreasResponses, PostApiV1FieldValuesData, PostApiV1FieldValuesErrors, PostApiV1FieldValuesResponses, PostApiV1FieldValuesUpdatesData, PostApiV1FieldValuesUpdatesErrors, PostApiV1FieldValuesUpdatesResponses, PostApiV1FilterData, PostApiV1FilterErrors, PostApiV1FilterResponses, PostApiV1OptionalAttributesByPrognosisIdData, PostApiV1OptionalAttributesByPrognosisIdErrors, PostApiV1OptionalAttributesByPrognosisIdResponses, PostApiV1PrognosedDepthsUpdatesData, PostApiV1PrognosedDepthsUpdatesErrors, PostApiV1PrognosedDepthsUpdatesResponses, PostApiV1PrognosesByIdCopyData, PostApiV1PrognosesByIdCopyErrors, PostApiV1PrognosesByIdCopyResponses, PostApiV1PrognosesByIdOutdatedEntriesDismissData, PostApiV1PrognosesByIdOutdatedEntriesDismissErrors, PostApiV1PrognosesByIdOutdatedEntriesDismissResponses, PostApiV1PrognosesData, PostApiV1PrognosesDetailsData, PostApiV1PrognosesDetailsErrors, PostApiV1PrognosesDetailsResponses, PostApiV1PrognosesErrors, PostApiV1PrognosesResponses, PostApiV1PrognosisSubscriptionData, PostApiV1PrognosisSubscriptionErrors, PostApiV1PrognosisSubscriptionResponses, PostApiV1SmdaUpdateRelationData, PostApiV1SmdaUpdateRelationErrors, PostApiV1SmdaUpdateRelationResponses, PostApiV1TargetsUpdatesData, PostApiV1TargetsUpdatesErrors, PostApiV1TargetsUpdatesResponses, PostApiV1WellborePicksUpdatesData, PostApiV1WellborePicksUpdatesErrors, PostApiV1WellborePicksUpdatesResponses, PostApiV1WellboresUpdatesData, PostApiV1WellboresUpdatesErrors, PostApiV1WellboresUpdatesResponses, PostApiV1WellPathsUpdatesData, PostApiV1WellPathsUpdatesErrors, PostApiV1WellPathsUpdatesResponses, PutApiV1FieldValuesAreasByIdData, PutApiV1FieldValuesAreasByIdErrors, PutApiV1FieldValuesAreasByIdResponses, PutApiV1FieldValuesByIdData, PutApiV1FieldValuesByIdErrors, PutApiV1FieldValuesByIdResponses, PutApiV1OptionalAttributesByPrognosisIdData, PutApiV1OptionalAttributesByPrognosisIdErrors, PutApiV1OptionalAttributesByPrognosisIdResponses, PutApiV1PrognosesDetailsData, PutApiV1PrognosesDetailsErrors, PutApiV1PrognosesDetailsResponses, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareData, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareErrors, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponses, PutApiV1UserDefaultViewData, PutApiV1UserDefaultViewErrors, PutApiV1UserDefaultViewResponses, PutApiV1UserFavoriteFieldsByFieldUuidData, PutApiV1UserFavoriteFieldsByFieldUuidErrors, PutApiV1UserFavoriteFieldsByFieldUuidResponses, SaveFilterData, SaveFilterResponses, UpdateFieldConfigData, UpdateFieldConfigResponses, UpdateFilterData, UpdateFilterResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Assign wellbores to an area
 */
export const postApiV1AreaAssignmentAssignWellbores = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1AreaAssignmentAssignWellboresData, ThrowOnError>): RequestResult<PostApiV1AreaAssignmentAssignWellboresResponses, PostApiV1AreaAssignmentAssignWellboresErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1AreaAssignmentAssignWellboresResponses, PostApiV1AreaAssignmentAssignWellboresErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/AreaAssignment/assign-wellbores',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Get all wellbore area assignments for a field
 */
export const getApiV1AreaAssignmentFieldByFieldGuid = <ThrowOnError extends boolean = false>(options: Options<GetApiV1AreaAssignmentFieldByFieldGuidData, ThrowOnError>): RequestResult<GetApiV1AreaAssignmentFieldByFieldGuidResponses, GetApiV1AreaAssignmentFieldByFieldGuidErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1AreaAssignmentFieldByFieldGuidResponses, GetApiV1AreaAssignmentFieldByFieldGuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/AreaAssignment/field/{fieldGuid}',
    ...options
});

/**
 * Get access token for blob storage
 */
export const getApiV1BlobAccessToken = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1BlobAccessTokenData, ThrowOnError>): RequestResult<GetApiV1BlobAccessTokenResponses, GetApiV1BlobAccessTokenErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1BlobAccessTokenResponses, GetApiV1BlobAccessTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Blob/AccessToken',
    ...options
});

/**
 * Delete a blob
 */
export const deleteApiV1BlobByPrognosisIdByBlobName = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1BlobByPrognosisIdByBlobNameData, ThrowOnError>): RequestResult<DeleteApiV1BlobByPrognosisIdByBlobNameResponses, DeleteApiV1BlobByPrognosisIdByBlobNameErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1BlobByPrognosisIdByBlobNameResponses, DeleteApiV1BlobByPrognosisIdByBlobNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Blob/{prognosisId}/{blobName}',
    ...options
});

/**
 * Get blob by blob name
 */
export const getApiV1BlobByPrognosisIdByBlobName = <ThrowOnError extends boolean = false>(options: Options<GetApiV1BlobByPrognosisIdByBlobNameData, ThrowOnError>): RequestResult<GetApiV1BlobByPrognosisIdByBlobNameResponses, GetApiV1BlobByPrognosisIdByBlobNameErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1BlobByPrognosisIdByBlobNameResponses, GetApiV1BlobByPrognosisIdByBlobNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Blob/{prognosisId}/{blobName}',
    ...options
});

/**
 * Upload a new blob
 */
export const postApiV1BlobByPrognosisId = <ThrowOnError extends boolean = false>(options: Options<PostApiV1BlobByPrognosisIdData, ThrowOnError>): RequestResult<PostApiV1BlobByPrognosisIdResponses, PostApiV1BlobByPrognosisIdErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1BlobByPrognosisIdResponses, PostApiV1BlobByPrognosisIdErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Blob/{prognosisId}',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Clear all entries from the Redis cache
 */
export const clearCache = <ThrowOnError extends boolean = false>(options?: Options<ClearCacheData, ThrowOnError>): RequestResult<ClearCacheResponses, ClearCacheErrors, ThrowOnError> => (options?.client ?? client).delete<ClearCacheResponses, ClearCacheErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Cache/clear',
    ...options
});

/**
 * Get well target
 */
export const getApiV1CiWellTargetsByTargetUuid = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CiWellTargetsByTargetUuidData, ThrowOnError>): RequestResult<GetApiV1CiWellTargetsByTargetUuidResponses, GetApiV1CiWellTargetsByTargetUuidErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1CiWellTargetsByTargetUuidResponses, GetApiV1CiWellTargetsByTargetUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Ci/wellTargets/{targetUuid}',
    ...options
});

/**
 * Get well targets for a field
 */
export const getApiV1CiWellTargetsFieldByFieldUuid = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CiWellTargetsFieldByFieldUuidData, ThrowOnError>): RequestResult<GetApiV1CiWellTargetsFieldByFieldUuidResponses, GetApiV1CiWellTargetsFieldByFieldUuidErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1CiWellTargetsFieldByFieldUuidResponses, GetApiV1CiWellTargetsFieldByFieldUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Ci/wellTargets/field/{fieldUuid}',
    ...options
});

export const getDataTypes = <ThrowOnError extends boolean = false>(options?: Options<GetDataTypesData, ThrowOnError>): RequestResult<GetDataTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDataTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Config/datatypes',
    ...options
});

export const getPressureTypes = <ThrowOnError extends boolean = false>(options?: Options<GetPressureTypesData, ThrowOnError>): RequestResult<GetPressureTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPressureTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Config/pressureTypes',
    ...options
});

export const getMeasurementTypes = <ThrowOnError extends boolean = false>(options?: Options<GetMeasurementTypesData, ThrowOnError>): RequestResult<GetMeasurementTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMeasurementTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Config/measurementtypes',
    ...options
});

export const getConfig = <ThrowOnError extends boolean = false>(options?: Options<GetConfigData, ThrowOnError>): RequestResult<GetConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Config',
    ...options
});

/**
 * Retrieves all field configs
 */
export const getFieldConfigs = <ThrowOnError extends boolean = false>(options?: Options<GetFieldConfigsData, ThrowOnError>): RequestResult<GetFieldConfigsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetFieldConfigsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Config/fieldConfig',
    ...options
});

/**
 * Retrieves field config for given fieldId
 */
export const getFieldConfig = <ThrowOnError extends boolean = false>(options: Options<GetFieldConfigData, ThrowOnError>): RequestResult<GetFieldConfigResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetFieldConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Config/fieldConfig/{fieldUuid}',
    ...options
});

/**
 * Update field config for given fieldId
 */
export const updateFieldConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateFieldConfigData, ThrowOnError>): RequestResult<UpdateFieldConfigResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateFieldConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Config/fieldConfig/{fieldGuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Get equipment for a wellbore from ssdl
 */
export const getEquipment = <ThrowOnError extends boolean = false>(options: Options<GetEquipmentData, ThrowOnError>): RequestResult<GetEquipmentResponses, GetEquipmentErrors, ThrowOnError> => (options.client ?? client).get<GetEquipmentResponses, GetEquipmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/EquipmentMapping/{wellboreUuid}/equipment',
    ...options
});

/**
 * Post equipment for a wellbore to database
 */
export const addEquipment = <ThrowOnError extends boolean = false>(options: Options<AddEquipmentData, ThrowOnError>): RequestResult<AddEquipmentResponses, AddEquipmentErrors, ThrowOnError> => (options.client ?? client).post<AddEquipmentResponses, AddEquipmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/EquipmentMapping/field/{fieldUuid}/wellbore/{wellboreUuid}/equipment',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Get outlines for a field
 */
export const getFieldOutlines = <ThrowOnError extends boolean = false>(options: Options<GetFieldOutlinesData, ThrowOnError>): RequestResult<GetFieldOutlinesResponses, GetFieldOutlinesErrors, ThrowOnError> => (options.client ?? client).get<GetFieldOutlinesResponses, GetFieldOutlinesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Field/{fieldUuid}/Outlines',
    ...options
});

/**
 * Get fault lines for a field
 */
export const getFieldFaultLines = <ThrowOnError extends boolean = false>(options: Options<GetFieldFaultLinesData, ThrowOnError>): RequestResult<GetFieldFaultLinesResponses, GetFieldFaultLinesErrors, ThrowOnError> => (options.client ?? client).get<GetFieldFaultLinesResponses, GetFieldFaultLinesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Field/{fieldUuid}/FaultLines',
    ...options
});

/**
 * GetArea outlines for a field
 */
export const getAreas = <ThrowOnError extends boolean = false>(options: Options<GetAreasData, ThrowOnError>): RequestResult<GetAreasResponses, GetAreasErrors, ThrowOnError> => (options.client ?? client).get<GetAreasResponses, GetAreasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Field/{fieldUuid}/areas',
    ...options
});

/**
 * Get Wells in area
 */
export const getWellsInArea = <ThrowOnError extends boolean = false>(options: Options<GetWellsInAreaData, ThrowOnError>): RequestResult<GetWellsInAreaResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetWellsInAreaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Field/{fieldUuId}/areas/{area}/wells',
    ...options
});

/**
 * wellpositions for a field
 */
export const getWellpositions = <ThrowOnError extends boolean = false>(options: Options<GetWellpositionsData, ThrowOnError>): RequestResult<GetWellpositionsResponses, GetWellpositionsErrors, ThrowOnError> => (options.client ?? client).get<GetWellpositionsResponses, GetWellpositionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Field/{fieldUuid}/wellpositions',
    ...options
});

/**
 * Get field values for a field
 */
export const getApiV1FieldValuesFieldByFieldUuid = <ThrowOnError extends boolean = false>(options: Options<GetApiV1FieldValuesFieldByFieldUuidData, ThrowOnError>): RequestResult<GetApiV1FieldValuesFieldByFieldUuidResponses, GetApiV1FieldValuesFieldByFieldUuidErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1FieldValuesFieldByFieldUuidResponses, GetApiV1FieldValuesFieldByFieldUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/FieldValues/Field/{fieldUuid}',
    ...options
});

/**
 * Create new field values
 */
export const postApiV1FieldValues = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1FieldValuesData, ThrowOnError>): RequestResult<PostApiV1FieldValuesResponses, PostApiV1FieldValuesErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1FieldValuesResponses, PostApiV1FieldValuesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/FieldValues',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Delete field values
 */
export const deleteApiV1FieldValuesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1FieldValuesByIdData, ThrowOnError>): RequestResult<DeleteApiV1FieldValuesByIdResponses, DeleteApiV1FieldValuesByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1FieldValuesByIdResponses, DeleteApiV1FieldValuesByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/FieldValues/{id}',
    ...options
});

/**
 * Update field values
 */
export const putApiV1FieldValuesById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1FieldValuesByIdData, ThrowOnError>): RequestResult<PutApiV1FieldValuesByIdResponses, PutApiV1FieldValuesByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1FieldValuesByIdResponses, PutApiV1FieldValuesByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/FieldValues/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Create new area
 */
export const postApiV1FieldValuesAreas = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1FieldValuesAreasData, ThrowOnError>): RequestResult<PostApiV1FieldValuesAreasResponses, PostApiV1FieldValuesAreasErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1FieldValuesAreasResponses, PostApiV1FieldValuesAreasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/FieldValues/areas',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Delete area
 */
export const deleteApiV1FieldValuesAreasById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1FieldValuesAreasByIdData, ThrowOnError>): RequestResult<DeleteApiV1FieldValuesAreasByIdResponses, DeleteApiV1FieldValuesAreasByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1FieldValuesAreasByIdResponses, DeleteApiV1FieldValuesAreasByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/FieldValues/areas/{id}',
    ...options
});

/**
 * Update area
 */
export const putApiV1FieldValuesAreasById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1FieldValuesAreasByIdData, ThrowOnError>): RequestResult<PutApiV1FieldValuesAreasByIdResponses, PutApiV1FieldValuesAreasByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1FieldValuesAreasByIdResponses, PutApiV1FieldValuesAreasByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/FieldValues/areas/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Get missing field values for a field
 */
export const getApiV1FieldValuesFieldValuesWarningByFieldUuid = <ThrowOnError extends boolean = false>(options: Options<GetApiV1FieldValuesFieldValuesWarningByFieldUuidData, ThrowOnError>): RequestResult<GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponses, GetApiV1FieldValuesFieldValuesWarningByFieldUuidErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1FieldValuesFieldValuesWarningByFieldUuidResponses, GetApiV1FieldValuesFieldValuesWarningByFieldUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/FieldValues/FieldValuesWarning/{fieldUuid}',
    ...options
});

/**
 * Get user filters
 */
export const getApiV1Filter = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1FilterData, ThrowOnError>): RequestResult<GetApiV1FilterResponses, GetApiV1FilterErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1FilterResponses, GetApiV1FilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Filter',
    ...options
});

/**
 * Create a new filter
 */
export const postApiV1Filter = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1FilterData, ThrowOnError>): RequestResult<PostApiV1FilterResponses, PostApiV1FilterErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1FilterResponses, PostApiV1FilterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Filter',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Delete a filter
 */
export const deleteApiV1FilterById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1FilterByIdData, ThrowOnError>): RequestResult<DeleteApiV1FilterByIdResponses, DeleteApiV1FilterByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1FilterByIdResponses, DeleteApiV1FilterByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Filter/{id}',
    ...options
});

/**
 * Update filter title
 */
export const patchApiV1FilterById = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1FilterByIdData, ThrowOnError>): RequestResult<PatchApiV1FilterByIdResponses, PatchApiV1FilterByIdErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1FilterByIdResponses, PatchApiV1FilterByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Filter/{id}',
    ...options
});

export const getApiV1Health = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1HealthData, ThrowOnError>): RequestResult<GetApiV1HealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1HealthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Health',
    ...options
});

export const getHelpLines = <ThrowOnError extends boolean = false>(options: Options<GetHelpLinesData, ThrowOnError>): RequestResult<GetHelpLinesResponses, unknown, ThrowOnError> => (options.client ?? client).post<GetHelpLinesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/HelpLine/{fieldUuId}',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

export const getStatPressHelpLines = <ThrowOnError extends boolean = false>(options: Options<GetStatPressHelpLinesData, ThrowOnError>): RequestResult<GetStatPressHelpLinesResponses, unknown, ThrowOnError> => (options.client ?? client).post<GetStatPressHelpLinesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/HelpLine/{fieldUuId}/getStatPressPressure',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Get last submitted prognosis
 */
export const getApiV1PrognosesByPrognosisIdLastSubmitted = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByPrognosisIdLastSubmittedData, ThrowOnError>): RequestResult<GetApiV1PrognosesByPrognosisIdLastSubmittedResponses, GetApiV1PrognosesByPrognosisIdLastSubmittedErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByPrognosisIdLastSubmittedResponses, GetApiV1PrognosesByPrognosisIdLastSubmittedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{prognosisId}/LastSubmitted',
    ...options
});

/**
 * Get last submitted prognosis details
 */
export const getApiV1PrognosesByPrognosisIdDetailsLastSubmitted = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedData, ThrowOnError>): RequestResult<GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponses, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedResponses, GetApiV1PrognosesByPrognosisIdDetailsLastSubmittedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{prognosisId}/Details/LastSubmitted',
    ...options
});

/**
 * Get lookup values
 */
export const getApiV1PrognosesLookupValues = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PrognosesLookupValuesData, ThrowOnError>): RequestResult<GetApiV1PrognosesLookupValuesResponses, GetApiV1PrognosesLookupValuesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1PrognosesLookupValuesResponses, GetApiV1PrognosesLookupValuesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/LookupValues',
    ...options
});

export const getFilters = <ThrowOnError extends boolean = false>(options?: Options<GetFiltersData, ThrowOnError>): RequestResult<GetFiltersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetFiltersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/MeasuredDataFilter',
    ...options
});

/**
 * Saves a measuredDataFilter
 */
export const saveFilter = <ThrowOnError extends boolean = false>(options?: Options<SaveFilterData, ThrowOnError>): RequestResult<SaveFilterResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SaveFilterResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/MeasuredDataFilter',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Updates a measuredDataFilter
 */
export const updateFilter = <ThrowOnError extends boolean = false>(options?: Options<UpdateFilterData, ThrowOnError>): RequestResult<UpdateFilterResponses, unknown, ThrowOnError> => (options?.client ?? client).put<UpdateFilterResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/MeasuredDataFilter',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Bulk updates filters
 */
export const bulkUpdateFilter = <ThrowOnError extends boolean = false>(options?: Options<BulkUpdateFilterData, ThrowOnError>): RequestResult<BulkUpdateFilterResponses, unknown, ThrowOnError> => (options?.client ?? client).put<BulkUpdateFilterResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/MeasuredDataFilter/bulkupdate',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Deletes a filter by id
 */
export const deleteFilterById = <ThrowOnError extends boolean = false>(options: Options<DeleteFilterByIdData, ThrowOnError>): RequestResult<DeleteFilterByIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteFilterByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/MeasuredDataFilter/{id}',
    ...options
});

/**
 * Gets a filter by id
 */
export const getFilterById = <ThrowOnError extends boolean = false>(options: Options<GetFilterByIdData, ThrowOnError>): RequestResult<GetFilterByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetFilterByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/MeasuredDataFilter/{id}',
    ...options
});

/**
 * Bulk Deletes  filters by id
 */
export const bulkDeleteFilterById = <ThrowOnError extends boolean = false>(options?: Options<BulkDeleteFilterByIdData, ThrowOnError>): RequestResult<BulkDeleteFilterByIdResponses, unknown, ThrowOnError> => (options?.client ?? client).post<BulkDeleteFilterByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/MeasuredDataFilter/bulkDelete',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Get optional attributes for a prognosis
 */
export const getApiV1OptionalAttributesByPrognosisId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OptionalAttributesByPrognosisIdData, ThrowOnError>): RequestResult<GetApiV1OptionalAttributesByPrognosisIdResponses, GetApiV1OptionalAttributesByPrognosisIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1OptionalAttributesByPrognosisIdResponses, GetApiV1OptionalAttributesByPrognosisIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/OptionalAttributes/{prognosisId}',
    ...options
});

/**
 * Create optional attributes for a prognosis
 */
export const postApiV1OptionalAttributesByPrognosisId = <ThrowOnError extends boolean = false>(options: Options<PostApiV1OptionalAttributesByPrognosisIdData, ThrowOnError>): RequestResult<PostApiV1OptionalAttributesByPrognosisIdResponses, PostApiV1OptionalAttributesByPrognosisIdErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1OptionalAttributesByPrognosisIdResponses, PostApiV1OptionalAttributesByPrognosisIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/OptionalAttributes/{prognosisId}',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Update optional attributes for a prognosis
 */
export const putApiV1OptionalAttributesByPrognosisId = <ThrowOnError extends boolean = false>(options: Options<PutApiV1OptionalAttributesByPrognosisIdData, ThrowOnError>): RequestResult<PutApiV1OptionalAttributesByPrognosisIdResponses, PutApiV1OptionalAttributesByPrognosisIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1OptionalAttributesByPrognosisIdResponses, PutApiV1OptionalAttributesByPrognosisIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/OptionalAttributes/{prognosisId}',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Get well paths for new wells
 */
export const getApiV1OsduWellboresByWellboreIdentifierWellpaths = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OsduWellboresByWellboreIdentifierWellpathsData, ThrowOnError>): RequestResult<GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponses, GetApiV1OsduWellboresByWellboreIdentifierWellpathsErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1OsduWellboresByWellboreIdentifierWellpathsResponses, GetApiV1OsduWellboresByWellboreIdentifierWellpathsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Osdu/wellbores/{wellboreIdentifier}/wellpaths',
    ...options
});

/**
 * Get well path by OSDU well path Id
 */
export const getApiV1OsduWellpathsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1OsduWellpathsByIdData, ThrowOnError>): RequestResult<GetApiV1OsduWellpathsByIdResponses, GetApiV1OsduWellpathsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1OsduWellpathsByIdResponses, GetApiV1OsduWellpathsByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Osdu/wellpaths/{id}',
    ...options
});

/**
 * Get overlapping prognoses by prognosis ID
 */
export const getApiV1PrognosesByPrognosisIdOverlapping = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByPrognosisIdOverlappingData, ThrowOnError>): RequestResult<GetApiV1PrognosesByPrognosisIdOverlappingResponses, GetApiV1PrognosesByPrognosisIdOverlappingErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByPrognosisIdOverlappingResponses, GetApiV1PrognosesByPrognosisIdOverlappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{prognosisId}/overlapping',
    ...options
});

/**
 * Get prognosed depth from Pozo
 *
 * Allowed DetailType values are ZoneTop or ZoneBase. Default value is ZoneTop. DetailType is not applicable for Total Depth and will be ignored.
 */
export const getApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepth = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthData, ThrowOnError>): RequestResult<GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponses, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthResponses, GetApiV1PozoPrognosisByIdStratColumnByStratColumnIdentifierStratUnitByStratUnitIdentifierPrognosedDepthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Pozo/prognosis/{id}/stratColumn/{stratColumnIdentifier}/stratUnit/{stratUnitIdentifier}/prognosedDepth',
    ...options
});

/**
 * Get faults from Pozo
 */
export const getApiV1PozoPrognosisByIdFaults = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PozoPrognosisByIdFaultsData, ThrowOnError>): RequestResult<GetApiV1PozoPrognosisByIdFaultsResponses, GetApiV1PozoPrognosisByIdFaultsErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PozoPrognosisByIdFaultsResponses, GetApiV1PozoPrognosisByIdFaultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Pozo/prognosis/{id}/faults',
    ...options
});

/**
 * Get pressuredata for a field flat
 */
export const getPressureDataByFieldFlat = <ThrowOnError extends boolean = false>(options: Options<GetPressureDataByFieldFlatData, ThrowOnError>): RequestResult<GetPressureDataByFieldFlatResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPressureDataByFieldFlatResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Pressure/Field/{fieldUuid}/pressureField',
    ...options
});

/**
 * Get heatmap data for a field
 */
export const getPressureHeatmap = <ThrowOnError extends boolean = false>(options: Options<GetPressureHeatmapData, ThrowOnError>): RequestResult<GetPressureHeatmapResponses, GetPressureHeatmapErrors, ThrowOnError> => (options.client ?? client).post<GetPressureHeatmapResponses, GetPressureHeatmapErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Pressure/Field/{fieldUuid}/heatmap',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Gets interpolated PI
 */
export const getPiLinePlot = <ThrowOnError extends boolean = false>(options: Options<GetPiLinePlotData, ThrowOnError>): RequestResult<GetPiLinePlotResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPiLinePlotResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Pressure/pressurecorrection/{fieldUuid}/GetPiLinePlot',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Get prognoses
 */
export const getApiV1Prognoses = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PrognosesData, ThrowOnError>): RequestResult<GetApiV1PrognosesResponses, GetApiV1PrognosesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1PrognosesResponses, GetApiV1PrognosesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses',
    ...options
});

/**
 * Create a new draft prognosis
 */
export const postApiV1Prognoses = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PrognosesData, ThrowOnError>): RequestResult<PostApiV1PrognosesResponses, PostApiV1PrognosesErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1PrognosesResponses, PostApiV1PrognosesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Delete prognosis
 */
export const deleteApiV1PrognosesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1PrognosesByIdData, ThrowOnError>): RequestResult<DeleteApiV1PrognosesByIdResponses, DeleteApiV1PrognosesByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1PrognosesByIdResponses, DeleteApiV1PrognosesByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}',
    ...options
});

/**
 * Get prognosis by id
 */
export const getApiV1PrognosesById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByIdData, ThrowOnError>): RequestResult<GetApiV1PrognosesByIdResponses, GetApiV1PrognosesByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByIdResponses, GetApiV1PrognosesByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}',
    ...options
});

/**
 * Get active prognosis by EDM wellboreId and scenarioId
 */
export const getApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdData, ThrowOnError>): RequestResult<GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponses, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdResponses, GetApiV1PrognosesEdmWellboreByEdmWellboreIdScenarioByScenarioIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/edmWellbore/{edmWellboreId}/scenario/{scenarioId}',
    ...options
});

/**
 * Get active prognoses by EDM wellboreId
 */
export const getApiV1PrognosesEdmWellboreByEdmWellboreId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesEdmWellboreByEdmWellboreIdData, ThrowOnError>): RequestResult<GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponses, GetApiV1PrognosesEdmWellboreByEdmWellboreIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesEdmWellboreByEdmWellboreIdResponses, GetApiV1PrognosesEdmWellboreByEdmWellboreIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/edmWellbore/{edmWellboreId}',
    ...options
});

/**
 * Create a copy of prognosis
 */
export const postApiV1PrognosesByIdCopy = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PrognosesByIdCopyData, ThrowOnError>): RequestResult<PostApiV1PrognosesByIdCopyResponses, PostApiV1PrognosesByIdCopyErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1PrognosesByIdCopyResponses, PostApiV1PrognosesByIdCopyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/copy',
    ...options
});

/**
 * Patch draft prognosis step 1
 */
export const patchApiV1PrognosesByIdStep1 = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdStep1Data, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdStep1Responses, PatchApiV1PrognosesByIdStep1Errors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdStep1Responses, PatchApiV1PrognosesByIdStep1Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/step-1',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Patch draft prognosis step 2
 */
export const patchApiV1PrognosesByIdStep2 = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdStep2Data, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdStep2Responses, PatchApiV1PrognosesByIdStep2Errors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdStep2Responses, PatchApiV1PrognosesByIdStep2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/step-2',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Patch draft prognosis step 3
 */
export const patchApiV1PrognosesByIdStep3 = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdStep3Data, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdStep3Responses, PatchApiV1PrognosesByIdStep3Errors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdStep3Responses, PatchApiV1PrognosesByIdStep3Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/step-3',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Patch draft prognosis step 5
 */
export const patchApiV1PrognosesByIdStep5 = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdStep5Data, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdStep5Responses, PatchApiV1PrognosesByIdStep5Errors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdStep5Responses, PatchApiV1PrognosesByIdStep5Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/step-5',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Patch prognosis step
 */
export const patchApiV1PrognosesByIdStep = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdStepData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdStepResponses, PatchApiV1PrognosesByIdStepErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdStepResponses, PatchApiV1PrognosesByIdStepErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/step',
    ...options
});

/**
 * Submit prognosis
 */
export const patchApiV1PrognosesByIdSubmit = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdSubmitData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdSubmitResponses, PatchApiV1PrognosesByIdSubmitErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdSubmitResponses, PatchApiV1PrognosesByIdSubmitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/submit',
    ...options
});

/**
 * Return prognosis to draft
 */
export const patchApiV1PrognosesByIdReturnToDraft = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdReturnToDraftData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdReturnToDraftResponses, PatchApiV1PrognosesByIdReturnToDraftErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdReturnToDraftResponses, PatchApiV1PrognosesByIdReturnToDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/returnToDraft',
    ...options
});

/**
 * Reject prognosis
 */
export const patchApiV1PrognosesByIdReject = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdRejectData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdRejectResponses, PatchApiV1PrognosesByIdRejectErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdRejectResponses, PatchApiV1PrognosesByIdRejectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/reject',
    ...options
});

/**
 * Retract prognosis
 */
export const patchApiV1PrognosesByIdRetract = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdRetractData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdRetractResponses, PatchApiV1PrognosesByIdRetractErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdRetractResponses, PatchApiV1PrognosesByIdRetractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/retract',
    ...options
});

/**
 * Approve prognosis
 */
export const patchApiV1PrognosesByIdApprove = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdApproveData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdApproveResponses, PatchApiV1PrognosesByIdApproveErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdApproveResponses, PatchApiV1PrognosesByIdApproveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/approve',
    ...options
});

/**
 * Expire prognosis
 */
export const patchApiV1PrognosesByIdExpire = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdExpireData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdExpireResponses, PatchApiV1PrognosesByIdExpireErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdExpireResponses, PatchApiV1PrognosesByIdExpireErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/expire',
    ...options
});

/**
 * Request approval retraction
 */
export const patchApiV1PrognosesByIdRequestApprovalRetraction = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdRequestApprovalRetractionData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdRequestApprovalRetractionResponses, PatchApiV1PrognosesByIdRequestApprovalRetractionErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdRequestApprovalRetractionResponses, PatchApiV1PrognosesByIdRequestApprovalRetractionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/requestApprovalRetraction',
    ...options
});

/**
 * Dismiss approval retraction request
 */
export const patchApiV1PrognosesByIdDismissApprovalRetraction = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdDismissApprovalRetractionData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdDismissApprovalRetractionResponses, PatchApiV1PrognosesByIdDismissApprovalRetractionErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdDismissApprovalRetractionResponses, PatchApiV1PrognosesByIdDismissApprovalRetractionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/dismissApprovalRetraction',
    ...options
});

/**
 * Request archiving
 */
export const patchApiV1PrognosesByIdRequestArchiving = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdRequestArchivingData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdRequestArchivingResponses, PatchApiV1PrognosesByIdRequestArchivingErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdRequestArchivingResponses, PatchApiV1PrognosesByIdRequestArchivingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/requestArchiving',
    ...options
});

/**
 * Dismiss archiving request
 */
export const patchApiV1PrognosesByIdDismissArchiving = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesByIdDismissArchivingData, ThrowOnError>): RequestResult<PatchApiV1PrognosesByIdDismissArchivingResponses, PatchApiV1PrognosesByIdDismissArchivingErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesByIdDismissArchivingResponses, PatchApiV1PrognosesByIdDismissArchivingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{id}/dismissArchiving',
    ...options
});

/**
 * Get details by prognosis ID
 */
export const getApiV1PrognosesByPrognosisIdDetails = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByPrognosisIdDetailsData, ThrowOnError>): RequestResult<GetApiV1PrognosesByPrognosisIdDetailsResponses, GetApiV1PrognosesByPrognosisIdDetailsErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByPrognosisIdDetailsResponses, GetApiV1PrognosesByPrognosisIdDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{prognosisId}/Details',
    ...options
});

/**
 * Delete details
 */
export const deleteApiV1PrognosesDetails = <ThrowOnError extends boolean = false>(options?: Options<DeleteApiV1PrognosesDetailsData, ThrowOnError>): RequestResult<DeleteApiV1PrognosesDetailsResponses, DeleteApiV1PrognosesDetailsErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteApiV1PrognosesDetailsResponses, DeleteApiV1PrognosesDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/Details',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Create new details
 */
export const postApiV1PrognosesDetails = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1PrognosesDetailsData, ThrowOnError>): RequestResult<PostApiV1PrognosesDetailsResponses, PostApiV1PrognosesDetailsErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1PrognosesDetailsResponses, PostApiV1PrognosesDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/Details',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Update details
 */
export const putApiV1PrognosesDetails = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1PrognosesDetailsData, ThrowOnError>): RequestResult<PutApiV1PrognosesDetailsResponses, PutApiV1PrognosesDetailsErrors, ThrowOnError> => (options?.client ?? client).put<PutApiV1PrognosesDetailsResponses, PutApiV1PrognosesDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/Details',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Patch detail comment
 */
export const patchApiV1PrognosesDetailsByDetailIdComment = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesDetailsByDetailIdCommentData, ThrowOnError>): RequestResult<PatchApiV1PrognosesDetailsByDetailIdCommentResponses, PatchApiV1PrognosesDetailsByDetailIdCommentErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesDetailsByDetailIdCommentResponses, PatchApiV1PrognosesDetailsByDetailIdCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/Details/{detailId}/comment',
    ...options
});

/**
 * Patch detail mark as done
 */
export const patchApiV1PrognosesDetailsByDetailIdMarkAsDone = <ThrowOnError extends boolean = false>(options: Options<PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneData, ThrowOnError>): RequestResult<PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponses, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneErrors, ThrowOnError> => (options.client ?? client).patch<PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneResponses, PatchApiV1PrognosesDetailsByDetailIdMarkAsDoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/Details/{detailId}/mark-as-done',
    ...options
});

/**
 * Get historic prognosis details
 */
export const getApiV1PrognosesDetailsHistoric = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesDetailsHistoricData, ThrowOnError>): RequestResult<GetApiV1PrognosesDetailsHistoricResponses, GetApiV1PrognosesDetailsHistoricErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesDetailsHistoricResponses, GetApiV1PrognosesDetailsHistoricErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/Details/Historic',
    ...options
});

/**
 * Get historic prognosis details for a commingled prognosis
 */
export const getApiV1PrognosesDetailsCommingledHistoric = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesDetailsCommingledHistoricData, ThrowOnError>): RequestResult<GetApiV1PrognosesDetailsCommingledHistoricResponses, GetApiV1PrognosesDetailsCommingledHistoricErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesDetailsCommingledHistoricResponses, GetApiV1PrognosesDetailsCommingledHistoricErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/Details/Commingled/Historic',
    ...options
});

/**
 * Get prognosis detail types
 */
export const getApiV1PrognosesDetailsTypes = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PrognosesDetailsTypesData, ThrowOnError>): RequestResult<GetApiV1PrognosesDetailsTypesResponses, GetApiV1PrognosesDetailsTypesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1PrognosesDetailsTypesResponses, GetApiV1PrognosesDetailsTypesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/details/types',
    ...options
});

/**
 * Get prognosis history
 */
export const getApiV1PrognosesByPrognosisIdHistory = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByPrognosisIdHistoryData, ThrowOnError>): RequestResult<GetApiV1PrognosesByPrognosisIdHistoryResponses, GetApiV1PrognosesByPrognosisIdHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByPrognosisIdHistoryResponses, GetApiV1PrognosesByPrognosisIdHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{prognosisId}/History',
    ...options
});

/**
 * Get prognosis revision history
 */
export const getApiV1PrognosesByPrognosisIdRevisions = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByPrognosisIdRevisionsData, ThrowOnError>): RequestResult<GetApiV1PrognosesByPrognosisIdRevisionsResponses, GetApiV1PrognosesByPrognosisIdRevisionsErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByPrognosisIdRevisionsResponses, GetApiV1PrognosesByPrognosisIdRevisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{prognosisId}/revisions',
    ...options
});

/**
 * Get the newest approved/historical prognosis
 */
export const getApiV1PrognosesByPrognosisIdRevisionsNewest = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByPrognosisIdRevisionsNewestData, ThrowOnError>): RequestResult<GetApiV1PrognosesByPrognosisIdRevisionsNewestResponses, GetApiV1PrognosesByPrognosisIdRevisionsNewestErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByPrognosisIdRevisionsNewestResponses, GetApiV1PrognosesByPrognosisIdRevisionsNewestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/{prognosisId}/revisions/newest',
    ...options
});

/**
 * Get outdated entries for a prognosis
 */
export const getApiV1PrognosesByIdOutdatedEntries = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrognosesByIdOutdatedEntriesData, ThrowOnError>): RequestResult<GetApiV1PrognosesByIdOutdatedEntriesResponses, GetApiV1PrognosesByIdOutdatedEntriesErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrognosesByIdOutdatedEntriesResponses, GetApiV1PrognosesByIdOutdatedEntriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prognoses/{id}/outdated-entries',
    ...options
});

/**
 * Dismiss all warnings for a prognosis
 */
export const postApiV1PrognosesByIdOutdatedEntriesDismiss = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PrognosesByIdOutdatedEntriesDismissData, ThrowOnError>): RequestResult<PostApiV1PrognosesByIdOutdatedEntriesDismissResponses, PostApiV1PrognosesByIdOutdatedEntriesDismissErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1PrognosesByIdOutdatedEntriesDismissResponses, PostApiV1PrognosesByIdOutdatedEntriesDismissErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prognoses/{id}/outdated-entries/dismiss',
    ...options
});

/**
 * Check for target updates
 */
export const postApiV1TargetsUpdates = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1TargetsUpdatesData, ThrowOnError>): RequestResult<PostApiV1TargetsUpdatesResponses, PostApiV1TargetsUpdatesErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1TargetsUpdatesResponses, PostApiV1TargetsUpdatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/targets/updates',
    ...options
});

/**
 * Check for wellbore updates
 */
export const postApiV1WellboresUpdates = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1WellboresUpdatesData, ThrowOnError>): RequestResult<PostApiV1WellboresUpdatesResponses, PostApiV1WellboresUpdatesErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1WellboresUpdatesResponses, PostApiV1WellboresUpdatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/wellbores/updates',
    ...options
});

/**
 * Check for well path updates
 */
export const postApiV1WellPathsUpdates = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1WellPathsUpdatesData, ThrowOnError>): RequestResult<PostApiV1WellPathsUpdatesResponses, PostApiV1WellPathsUpdatesErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1WellPathsUpdatesResponses, PostApiV1WellPathsUpdatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/well-paths/updates',
    ...options
});

/**
 * Check for field values updates
 */
export const postApiV1FieldValuesUpdates = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1FieldValuesUpdatesData, ThrowOnError>): RequestResult<PostApiV1FieldValuesUpdatesResponses, PostApiV1FieldValuesUpdatesErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1FieldValuesUpdatesResponses, PostApiV1FieldValuesUpdatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/field-values/updates',
    ...options
});

/**
 * Check for wellbore pick updates
 */
export const postApiV1WellborePicksUpdates = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1WellborePicksUpdatesData, ThrowOnError>): RequestResult<PostApiV1WellborePicksUpdatesResponses, PostApiV1WellborePicksUpdatesErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1WellborePicksUpdatesResponses, PostApiV1WellborePicksUpdatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/wellbore-picks/updates',
    ...options
});

/**
 * Check for prognosed depth updates
 */
export const postApiV1PrognosedDepthsUpdates = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1PrognosedDepthsUpdatesData, ThrowOnError>): RequestResult<PostApiV1PrognosedDepthsUpdatesResponses, PostApiV1PrognosedDepthsUpdatesErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1PrognosedDepthsUpdatesResponses, PostApiV1PrognosedDepthsUpdatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prognosed-depths/updates',
    ...options
});

/**
 * Unsubscribe from prognosis email notifications
 */
export const deleteApiV1PrognosisSubscription = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1PrognosisSubscriptionData, ThrowOnError>): RequestResult<DeleteApiV1PrognosisSubscriptionResponses, DeleteApiV1PrognosisSubscriptionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1PrognosisSubscriptionResponses, DeleteApiV1PrognosisSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/PrognosisSubscription',
    ...options
});

/**
 * Subscribe to prognosis email notifications
 */
export const postApiV1PrognosisSubscription = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PrognosisSubscriptionData, ThrowOnError>): RequestResult<PostApiV1PrognosisSubscriptionResponses, PostApiV1PrognosisSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1PrognosisSubscriptionResponses, PostApiV1PrognosisSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/PrognosisSubscription',
    ...options
});

/**
 * Share prognosis with users
 */
export const putApiV1PrognosisSubscriptionPrognosesByPrognosisIdShare = <ThrowOnError extends boolean = false>(options: Options<PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareData, ThrowOnError>): RequestResult<PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponses, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareResponses, PutApiV1PrognosisSubscriptionPrognosesByPrognosisIdShareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/PrognosisSubscription/prognoses/{prognosisId}/share',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Sync prognoses to PressureDB. Returns IDs of failed syncs
 */
export const getApiV1PrognosesSync = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PrognosesSyncData, ThrowOnError>): RequestResult<GetApiV1PrognosesSyncResponses, GetApiV1PrognosesSyncErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1PrognosesSyncResponses, GetApiV1PrognosesSyncErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/sync',
    ...options
});

/**
 * Sync prognoses and details to PressureDB. Returns IDs of failed syncs
 */
export const getApiV1PrognosesSyncWithDetails = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PrognosesSyncWithDetailsData, ThrowOnError>): RequestResult<GetApiV1PrognosesSyncWithDetailsResponses, GetApiV1PrognosesSyncWithDetailsErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1PrognosesSyncWithDetailsResponses, GetApiV1PrognosesSyncWithDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Prognoses/sync/withDetails',
    ...options
});

/**
 * Get top used reservoir zones
 */
export const getApiV1ReservoirZonesTopUsed = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ReservoirZonesTopUsedData, ThrowOnError>): RequestResult<GetApiV1ReservoirZonesTopUsedResponses, GetApiV1ReservoirZonesTopUsedErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1ReservoirZonesTopUsedResponses, GetApiV1ReservoirZonesTopUsedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ReservoirZones/topUsed',
    ...options
});

/**
 * Get last used reservoir zones
 */
export const getApiV1ReservoirZonesLastUsed = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ReservoirZonesLastUsedData, ThrowOnError>): RequestResult<GetApiV1ReservoirZonesLastUsedResponses, GetApiV1ReservoirZonesLastUsedErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1ReservoirZonesLastUsedResponses, GetApiV1ReservoirZonesLastUsedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ReservoirZones/lastUsed',
    ...options
});

/**
 * Get prognosis user analytics for SAM
 */
export const getApiV1SamUserAnalyticsPrognosis = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SamUserAnalyticsPrognosisData, ThrowOnError>): RequestResult<GetApiV1SamUserAnalyticsPrognosisResponses, GetApiV1SamUserAnalyticsPrognosisErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1SamUserAnalyticsPrognosisResponses, GetApiV1SamUserAnalyticsPrognosisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Sam/userAnalytics/prognosis',
    ...options
});

/**
 * Get wellbore by identifier
 */
export const getApiV1SmdaWellboresByWellboreIdentifier = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SmdaWellboresByWellboreIdentifierData, ThrowOnError>): RequestResult<GetApiV1SmdaWellboresByWellboreIdentifierResponses, GetApiV1SmdaWellboresByWellboreIdentifierErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SmdaWellboresByWellboreIdentifierResponses, GetApiV1SmdaWellboresByWellboreIdentifierErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Smda/Wellbores/{wellboreIdentifier}',
    ...options
});

/**
 * Get wellbores by field Uuid
 */
export const getApiV1SmdaFieldsByFieldUuidWellboresAll = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SmdaFieldsByFieldUuidWellboresAllData, ThrowOnError>): RequestResult<GetApiV1SmdaFieldsByFieldUuidWellboresAllResponses, GetApiV1SmdaFieldsByFieldUuidWellboresAllErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SmdaFieldsByFieldUuidWellboresAllResponses, GetApiV1SmdaFieldsByFieldUuidWellboresAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Smda/Fields/{fieldUuid}/Wellbores/All',
    ...options
});

/**
 * Get stratigraphic columns for a field
 */
export const getApiV1SmdaFieldsByFieldUuidStratColumns = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SmdaFieldsByFieldUuidStratColumnsData, ThrowOnError>): RequestResult<GetApiV1SmdaFieldsByFieldUuidStratColumnsResponses, GetApiV1SmdaFieldsByFieldUuidStratColumnsErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SmdaFieldsByFieldUuidStratColumnsResponses, GetApiV1SmdaFieldsByFieldUuidStratColumnsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Smda/Fields/{fieldUuid}/StratColumns',
    ...options
});

/**
 * Get all stratigraphic units by strat column identifier
 */
export const getApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAll = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllData, ThrowOnError>): RequestResult<GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponses, GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllResponses, GetApiV1SmdaWellboresStratColumnsByStratColumnIdentifierStratUnitsAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Smda/Wellbores/StratColumns/{stratColumnIdentifier}/StratUnits/All',
    ...options
});

/**
 * Get wellbore picks for a drilled wellbore
 *
 * Allowed DetailType values are ZoneTop or ZoneBase. Default value is ZoneTop. DetailType is not applicable for Total Depth and will be ignored.
 */
export const getApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPick = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickData, ThrowOnError>): RequestResult<GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponses, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickResponses, GetApiV1SmdaWellboresByWellboreUuidStratColumnsByStratColumnIdentifierStratUnitsByStratUnitIdentifierPickErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Smda/Wellbores/{wellboreUuid}/StratColumns/{stratColumnIdentifier}/StratUnits/{stratUnitIdentifier}/Pick',
    ...options
});

/**
 * Update old zone relations for prognosis details
 */
export const postApiV1SmdaUpdateRelation = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1SmdaUpdateRelationData, ThrowOnError>): RequestResult<PostApiV1SmdaUpdateRelationResponses, PostApiV1SmdaUpdateRelationErrors, ThrowOnError> => (options?.client ?? client).post<PostApiV1SmdaUpdateRelationResponses, PostApiV1SmdaUpdateRelationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Smda/update-relation',
    ...options
});

/**
 * Get perforations for a wellbore
 */
export const getApiV1SsdlWellboresByWellboreUuidPerforations = <ThrowOnError extends boolean = false>(options: Options<GetApiV1SsdlWellboresByWellboreUuidPerforationsData, ThrowOnError>): RequestResult<GetApiV1SsdlWellboresByWellboreUuidPerforationsResponses, GetApiV1SsdlWellboresByWellboreUuidPerforationsErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1SsdlWellboresByWellboreUuidPerforationsResponses, GetApiV1SsdlWellboresByWellboreUuidPerforationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Ssdl/wellbores/{wellboreUuid}/perforations',
    ...options
});

/**
 * Gets a token for the application with the provided clientId
 */
export const getToken = <ThrowOnError extends boolean = false>(options: Options<GetTokenData, ThrowOnError>): RequestResult<GetTokenResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Token/{clientId}',
    ...options
});

/**
 * Gets a Token for SAM Portal for the Current Radix Environment (development/staging/production)
 */
export const getSamPortalToken = <ThrowOnError extends boolean = false>(options?: Options<GetSamPortalTokenData, ThrowOnError>): RequestResult<GetSamPortalTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSamPortalTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Token/SamPortal',
    ...options
});

/**
 * Gets a token for SAM Portal in Production
 */
export const getSamPortalProductionToken = <ThrowOnError extends boolean = false>(options?: Options<GetSamPortalProductionTokenData, ThrowOnError>): RequestResult<GetSamPortalProductionTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSamPortalProductionTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Token/SamPortal/Production',
    ...options
});

/**
 * Get user access
 */
export const getApiV1UserUserAccess = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1UserUserAccessData, ThrowOnError>): RequestResult<GetApiV1UserUserAccessResponses, GetApiV1UserUserAccessErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1UserUserAccessResponses, GetApiV1UserUserAccessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/UserAccess',
    ...options
});

/**
 * Checks what accesses current user has, PDM, SMDA, SSDL, OSDU, DataOffice, Pozo
 */
export const getApiV1UserAccessCheckCollectionByFieldUuid = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserAccessCheckCollectionByFieldUuidData, ThrowOnError>): RequestResult<GetApiV1UserAccessCheckCollectionByFieldUuidResponses, GetApiV1UserAccessCheckCollectionByFieldUuidErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserAccessCheckCollectionByFieldUuidResponses, GetApiV1UserAccessCheckCollectionByFieldUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/accessCheckCollection/{fieldUuid}',
    ...options
});

/**
 * Get accesses that the user does not have and will need in the future
 */
export const getApiV1UserFutureAccesses = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserFutureAccessesData, ThrowOnError>): RequestResult<GetApiV1UserFutureAccessesResponses, GetApiV1UserFutureAccessesErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserFutureAccessesResponses, GetApiV1UserFutureAccessesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/future-accesses',
    ...options
});

/**
 * Get main approvers by field with filtering out the current user
 */
export const getApiV1UserApproversByFieldIdentifier = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserApproversByFieldIdentifierData, ThrowOnError>): RequestResult<GetApiV1UserApproversByFieldIdentifierResponses, GetApiV1UserApproversByFieldIdentifierErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserApproversByFieldIdentifierResponses, GetApiV1UserApproversByFieldIdentifierErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/Approvers/{fieldIdentifier}',
    ...options
});

/**
 * Get main approvers by field without filtering out the current user
 */
export const getApiV1UserApproversByFieldIdentifierAll = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserApproversByFieldIdentifierAllData, ThrowOnError>): RequestResult<GetApiV1UserApproversByFieldIdentifierAllResponses, GetApiV1UserApproversByFieldIdentifierAllErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserApproversByFieldIdentifierAllResponses, GetApiV1UserApproversByFieldIdentifierAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/Approvers/{fieldIdentifier}/all',
    ...options
});

/**
 * Get submitters by field with filtering out the current user
 */
export const getApiV1UserSubmittersByFieldIdentifier = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserSubmittersByFieldIdentifierData, ThrowOnError>): RequestResult<GetApiV1UserSubmittersByFieldIdentifierResponses, GetApiV1UserSubmittersByFieldIdentifierErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserSubmittersByFieldIdentifierResponses, GetApiV1UserSubmittersByFieldIdentifierErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/submitters/{fieldIdentifier}',
    ...options
});

/**
 * Get submitters by field without filtering out the current user
 */
export const getApiV1UserSubmittersByFieldIdentifierAll = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserSubmittersByFieldIdentifierAllData, ThrowOnError>): RequestResult<GetApiV1UserSubmittersByFieldIdentifierAllResponses, GetApiV1UserSubmittersByFieldIdentifierAllErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserSubmittersByFieldIdentifierAllResponses, GetApiV1UserSubmittersByFieldIdentifierAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/submitters/{fieldIdentifier}/all',
    ...options
});

/**
 * Get backup approvers by field with filtering out the current user
 */
export const getApiV1UserApproversByFieldIdentifierBackup = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserApproversByFieldIdentifierBackupData, ThrowOnError>): RequestResult<GetApiV1UserApproversByFieldIdentifierBackupResponses, GetApiV1UserApproversByFieldIdentifierBackupErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserApproversByFieldIdentifierBackupResponses, GetApiV1UserApproversByFieldIdentifierBackupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/Approvers/{fieldIdentifier}/Backup',
    ...options
});

/**
 * Get backup approvers by field without filtering out the current user
 */
export const getApiV1UserApproversByFieldIdentifierBackupAll = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserApproversByFieldIdentifierBackupAllData, ThrowOnError>): RequestResult<GetApiV1UserApproversByFieldIdentifierBackupAllResponses, GetApiV1UserApproversByFieldIdentifierBackupAllErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserApproversByFieldIdentifierBackupAllResponses, GetApiV1UserApproversByFieldIdentifierBackupAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/Approvers/{fieldIdentifier}/Backup/all',
    ...options
});

/**
 * Search for users by name or email - top 25
 */
export const getApiV1User = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserData, ThrowOnError>): RequestResult<GetApiV1UserResponses, GetApiV1UserErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserResponses, GetApiV1UserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User',
    ...options
});

/**
 * Get users by shortnames
 */
export const getApiV1UserShortnames = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1UserShortnamesData, ThrowOnError>): RequestResult<GetApiV1UserShortnamesResponses, GetApiV1UserShortnamesErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1UserShortnamesResponses, GetApiV1UserShortnamesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/shortnames',
    ...options
});

/**
 * Get user's photo
 */
export const getApiV1UserPhotoByShortname = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserPhotoByShortnameData, ThrowOnError>): RequestResult<GetApiV1UserPhotoByShortnameResponses, GetApiV1UserPhotoByShortnameErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UserPhotoByShortnameResponses, GetApiV1UserPhotoByShortnameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/Photo/{shortname}',
    ...options
});

/**
 * Get user default view
 */
export const getApiV1UserDefaultView = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1UserDefaultViewData, ThrowOnError>): RequestResult<GetApiV1UserDefaultViewResponses, GetApiV1UserDefaultViewErrors, ThrowOnError> => (options?.client ?? client).get<GetApiV1UserDefaultViewResponses, GetApiV1UserDefaultViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/defaultView',
    ...options
});

/**
 * Update user default view
 */
export const putApiV1UserDefaultView = <ThrowOnError extends boolean = false>(options?: Options<PutApiV1UserDefaultViewData, ThrowOnError>): RequestResult<PutApiV1UserDefaultViewResponses, PutApiV1UserDefaultViewErrors, ThrowOnError> => (options?.client ?? client).put<PutApiV1UserDefaultViewResponses, PutApiV1UserDefaultViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/defaultView',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options?.headers
    }
});

/**
 * Update user favorite fields
 */
export const putApiV1UserFavoriteFieldsByFieldUuid = <ThrowOnError extends boolean = false>(options: Options<PutApiV1UserFavoriteFieldsByFieldUuidData, ThrowOnError>): RequestResult<PutApiV1UserFavoriteFieldsByFieldUuidResponses, PutApiV1UserFavoriteFieldsByFieldUuidErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1UserFavoriteFieldsByFieldUuidResponses, PutApiV1UserFavoriteFieldsByFieldUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/User/favoriteFields/{fieldUuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers
    }
});

/**
 * Get drilled wells for a field
 */
export const getDrilledWellsFeaturesByField = <ThrowOnError extends boolean = false>(options: Options<GetDrilledWellsFeaturesByFieldData, ThrowOnError>): RequestResult<GetDrilledWellsFeaturesByFieldResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetDrilledWellsFeaturesByFieldResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/Well/{fieldUuId}/drilledwells',
    ...options
});
